import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {SaleOrderProvider} from "../../providers/sale-order/sale-order";
import {SaleOrderPage} from "../sale-order/sale-order";

/**
 * Generated class for the SalesOrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sales-orders',
  templateUrl: 'sales-orders.html',
})
export class SalesOrdersPage {
  private static MIN_SEARCH_LENGTH: number = 5;

  minSearchLength = SalesOrdersPage.MIN_SEARCH_LENGTH;
  term: string = '';
  searchInfoTitle: string = '';
  searchInfoText: string = '';
  searchInfoClass: string = '';
  results: any = [];
  isSearching: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private saleOrderProvider: SaleOrderProvider,
    ) {
  }

  ionViewDidLoad() {
    this.term = localStorage.getItem('search-term');
    this.search();
  }

  search() {
    this.results = [];

    localStorage.setItem('search-term', this.term);

    if (this.term && this.term.length > 0 && this.term.length < this.minSearchLength) {
      this.searchInfoTitle = 'Unvollständige Suche';
      this.searchInfoText = `Für eine Suche müssen mindestens ${this.minSearchLength} Zeichen eingegeben werden.`;
      this.searchInfoClass = 'bg-warning';
    } else if (!this.term || this.term.length == 0) {
      this.searchInfoTitle = 'Suche nach Aufträgen';
      this.searchInfoText = `Geben Sie mindestens ${this.minSearchLength} Zeichen für eine Suche ein.`;
      this.searchInfoClass = 'bg-halflight';
    } else {
      this.searchInfoText = '';
      this.searchInfoTitle = '';
      this.searchInfoClass = '';

      this.searchNumber(this.term);
    }
  }

  private searchNumber(number: string) {
    this.isSearching = true;

    this.saleOrderProvider.search(number).then( data => {
      // @ts-ignore
      this.results = data;
      this.isSearching = false;
    });
  }

  goToSaleOrder(saleOrder: any) {
    this.navCtrl.push(SaleOrderPage, { name: saleOrder.name });
  }

}



// WEBPACK FOOTER //
// ./src/pages/sales-orders/sales-orders.ts